import Splide from "@splidejs/splide";

let mainSliders = [];
let thumbSliders = [];

document.addEventListener('DOMContentLoaded', function () {
    // Do stuff

    // Initialize Icons Block Slider
    // var elms = document.getElementsByClassName( 'product-splide' );
    // for ( var i = 0; i < elms.length; i++ ) {
    //     new Splide( elms[ i ] ).mount();
    // }

    document.querySelectorAll('.wp-block-icb-product-slider').forEach(function(block) {

        // block.querySelectorAll('.product-gallery').forEach(function (el) {
          var main = new Splide( block.querySelector('.splide.main'), {
            type      : 'fade',
            autoWidth: true,
            // fixedHeight : 450,
            // heightRatio : 0.6,
            rewind    : true,
            pagination: false,
            arrows    : false,
            useIndex : true,
            breakpoints : {
              640: {
                fixedHeight: 250,
              },
              // 768: {
              //   fixedHeight: 400,
              // },
              1024: {
                // fixedHeight: 400,
              },
            },
          } );
  
          var thumbnails = new Splide( block.querySelector('.splide.thumbnail'), {
            fixedWidth  : 120,
            fixedHeight : 90,
            // autoWidth: true,
            gap         : 15,
            rewind      : true,
            pagination  : false,
            isNavigation: true,
            useIndex : true,
            breakpoints : {
              640: {
                fixedHeight: 40,
                fixedWidth  : 60,
                gap         : 10,
              },
              768: {
                fixedHeight: 60,
                fixedWidth : 80,
                gap         : 10,
              },
            },
          } );
  
          mainSliders.push(main);
          thumbSliders.push(thumbnails);
  
          main.sync( thumbnails );
          main.mount();
          thumbnails.mount();
        // });
    
    });

});